import ControlFactory from '@/Factories/ControlFactory';
import ComponentManger from '@/Management/ComponentManager';
import ToolBar from '@/Controls/ToolBar';
import ToolBarViewModel from '@/ViewModels/Controls/ToolBarViewModel';

export default class ToolBarFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private ToolBarViewModel = ComponentManger.getViewModel<typeof ToolBarViewModel>('ToolBarViewModel');
    private ToolBar = ComponentManger.getControl<typeof ToolBar>('ToolBar');

    /**
     * @override
     */
    public viewModel: ToolBarViewModel;

    public constructor(params: any) {
        super(params);

        this.labelPosition = 'None';
        this.colspan = 'Fill';
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = this.detailViewItem.viewModel;
        this.control = new this.ToolBar(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        return this.jQueryControl;
    }
}

ComponentManger.setFactory('ToolBar', ToolBarFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');